import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { auth } from '../../../firebase/index';

class Logout extends Component {
    componentDidMount() {
        auth.signOut();
    }

    render() {
        return <Navigate to="/" replace />;
    }
}

export default Logout;
